import React from "react";
import { fmtEuro } from "@/lib/format";

export const delta = (cur, ly) => (ly ? ((cur - ly) / Math.abs(ly)) * 100 : null);

export const Delta = ({ cur, ly, invert = false, testid, dark, lyYear = new Date().getFullYear() - 1 }) => {
  const d = delta(cur, ly);
  if (d === null) return <span className="text-[11px] text-[#B9AE9A]" data-testid={testid}>χωρίς δεδομένα {lyYear}</span>;
  const good = invert ? d <= 0 : d >= 0;
  const color = dark ? (good ? "text-[#86EFAC]" : "text-[#FCA5A5]") : (good ? "text-[#3C7A3C]" : "text-[#991B1B]");
  return (
    <span data-testid={testid} className={`text-[11px] font-semibold tabular ${color}`}>
      {d >= 0 ? "▲" : "▼"} {Math.abs(d).toFixed(1)}% vs πέρσι
    </span>
  );
};

export const KpiCard = ({ label, value, ly, cur, fmt = fmtEuro, invert, dark, testid, sub }) => (
  <div data-testid={testid}
    className={`rounded-2xl p-5 border transition-transform duration-200 hover:-translate-y-0.5 ${dark ? "bg-[#45423C] border-[#45423C] text-white" : "bg-white border-[#E3DED4]"}`}>
    <div className={`text-[10px] font-mono uppercase tracking-widest ${dark ? "text-[#B9AE9A]" : "text-[#6F6A60]"}`}>{label}</div>
    <div className={`font-serif text-2xl md:text-3xl mt-2 tabular ${dark ? "text-white" : "text-[#45423C]"}`}>{fmt(value)}</div>
    <div className="mt-1 flex flex-wrap items-center gap-x-2">
      {ly !== undefined && <Delta cur={cur ?? value} ly={ly} invert={invert} dark={dark} testid={testid && `${testid}-delta`} />}
      {ly !== undefined && <span className={`text-[11px] tabular ${dark ? "text-white/50" : "text-[#B9AE9A]"}`}>πέρσι {fmt(ly)}</span>}
      {sub && <span className={`text-[11px] ${dark ? "text-white/60" : "text-[#6F6A60]"}`}>{sub}</span>}
    </div>
  </div>
);

export const Panel = ({ title, icon: Icon, children, testid, right, className = "" }) => (
  <div className={`rounded-2xl bg-white border border-[#E3DED4] p-5 md:p-6 ${className}`} data-testid={testid}>
    <div className="flex items-center justify-between gap-2 mb-4">
      <h2 className="text-base md:text-lg font-medium text-[#45423C] flex items-center gap-2">
        {Icon && <Icon className="h-4 w-4 text-[#C86235]" />} {title}
      </h2>
      {right}
    </div>
    {children}
  </div>
);
